<template>
  <div class="statistics-block">
    <div class="statistics-block-title">{{ blockData.title }}</div>
    <div class="statistics-list">
      <div
        class="statistics-item"
        :class="'row-' + blockData.row"
        v-for="(item, index) in blockData.list"
        :key="index"
      >
        <div class="item-name">{{ item.name }}</div>
        <div class="item-value">{{ item.value }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "pi-statistics-block",
  components: {
  },
  data() {
    return {};
  },
  props: {
    blockData: {
      type: Object,
      default: () => {
        return {
          title: "标题",
          row: 2,
          list: [],
        };
      },
    },
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="less" scoped>
.statistics-block {
  background-color: #fff;
  box-shadow: 0px 0px 0.1rem 0px #efeff4;
  border-radius: 0.16rem;
  padding: 0.2rem;
  margin-top: 0.2rem;
}
.statistics-block .statistics-block-title {
  font-size: 0.2rem;
  line-height: 0.28rem;
  color: #999999;
}
.statistics-list {
  margin-top: 0.3rem;
  display: flex;
  flex-wrap: wrap;
  border-left: 0.01rem solid #eeeeee;
  border-bottom: 0.01rem solid #eeeeee;
  box-sizing: border-box;
}
.statistics-item {
  border-top: 0.01rem solid #eeeeee;
  border-right: 0.01rem solid #eeeeee;
  box-sizing: border-box;
}
.statistics-item.row-2 {
  width: 50%;
}
.statistics-item.row-3 {
  width: 33.33%;
}
.statistics-item.row-4 {
  width: 25%;
}
.statistics-item .item-name,
.statistics-item .item-value {
  height: 0.7rem;
  line-height: 0.7rem;
  text-align: center;
}
.statistics-item .item-name {
  background-color: #f5f5f5;
  border-bottom: 0.01rem solid #eeeeee;
  font-size: 0.24rem;
  color: #999;
}
.statistics-item .item-value {
  font-size: 0.32rem;
  color: #000;
}
</style>
